import { Color } from "../enums/Color";
import { Font } from "../enums/Font";

export const statisticsPage = {
    mobile: {
        mainWrapper: {
            display: "flex",
            flexDirection: "column" as "column"
        },
        leftWrapper: {},
        rightWrapper: {
            padding: "6.76vw 4.83vw 0 4.83vw"
        },
        selectWrapper: {
            display: "flex",
            flexDirection: "column",
            margin: "4.83vw 0"
        },
        orgSelect: {
            marginLeft: "unset",                
            marginTop: "unset",
            buttonWrapper: { 
                width: "66.21vw"
            },
            button: {
                width: "auto"
            },
            hover: {
                width: "66.21vw"
            }
        },
        title: {
            fontSize: "6.04vw",
            fontWeight: "bold" as "bold",
            color: Color.LightBlack
        },
        jobNameWrapper: {
            display: "flex",
            flexDirection: "column" as "column",
            marginTop: "1.93vw",
            fontSize: "4.83vw",
            fontWeight: "bold" as "bold",
            color: Color.LightBlack
        },
        filterPanel: {
            marginTop: "4.83vw",
            width: "auto",
            height: "auto",
            border: "1px solid " + Color.MiddleAsh,
            borderRadius: "2.41vw",
            padding: "2.89vw",
            background: Color.White,
            jobSelect: {
                flexDirection: "row",
                marginLeft: "auto",                
                marginTop: "unset",
                label: {
                    fontSize: "3.86vw",
                    fontWeight: "unset",
                    alignSelf: "center"
                },
                button: {
                    width: "71.73vw",
                    height: "8.45vw",
                    marginTop: "unset",
                    marginLeft: "auto",
                    borderRadius: "2.41vw",
                    background: Color.LightAsh
                },
                buttonWrapper: {
                    border: "unset"
                },
                buttonText: {
                    marginLeft: "4.83vw",
                    maxWidth: "52vw",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis"
                },
                buttonIcon: {       
                    marginLeft: "auto",
                    marginRight: "3.6vw",
                    transition: "transform .1s ease-in-out",
                    hover: {
                        transform: "rotate(180deg)"
                    }
                },
                hover: {
                    width: "71.73vw",
                    height: "auto",
                    maxHeight: "40vw"
                }
            },
            date: {
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                marginTop: "3.62vw"
            },
            text: {
                fontSize: "3.86vw"
            },
            dateInput: {
                width: "64.17vw",
                height: "8.45vw",
                fontSize: "3.86vw",
                border: "none",
                padding: "0 2.73vw 0 4.83vw",
                borderRadius: "2.41vw",
                color: Color.SharpAsh,
                backgroundColor: Color.LightAsh,
                marginLeft: "auto"               
            },
            applyButton: {
                display: "flex",
                width: "34.78vw",
                height: "8.45vw",
                border: "none",
                borderRadius: "2.41vw",
                fontSize: "4.34vw",
                background: Color.Blue,
                color: Color.White,
                alignItems: "center",
                justifyContent: "center",
                margin: "3.86vw 0 0 auto"
            }
        },
        jobCategory: {
            display: "flex",
            flexDirection: "row" as "row",
            padding: "7.67vw 0 0 0",
            tag: {
                height: "8.45vw",
                lineHeight: "8.45vw",
                width: "auto",
                borderRadius: "6.04vw",
                background: Color.LightAsh,
                color: Color.SharpAsh,
                padding: "0 3.62vw",
                fontSize: "3.62vw",
                marginRight: "2.41vw",
                flex: "0 0 auto"
            },
            activeTag: {
                background: Color.Blue,
                color: Color.LightBlue
            }
        },
        exportExcel: {
            wrapper: {              
                margin: "7.72vw 0 0 0"
            },
            button: {
                display: "flex",
                width: "38.8vw",
                height: "7.73vw",
                border: "2px solid " + Color.Green,
                borderRadius: "2.41vw",
                fontSize: "3.38vw",
                color: Color.LightBlack,
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                marginLeft: "auto"
            },
            icon: {
                width: "3.84vw",
                height: "3.30vw",
                fill: Color.LightBlack,
                marginRight: "2.06vw"
            }
        },
        font: {
            fontFamily: Font.Poppins,
            fontWeight: "600"
        },
        applicationsSummary: {
            marginTop: "5.79vw",
            totalApplications: {
                background: Color.LightBlue,
                width: "90.33vw",
                height: "27.79vw",
                borderRadius: "3.62vw",
                paddingTop: "6.03vw",
                count: {
                    fontSize: "10.62vw",
                    justifySelf: "center",
                    color: Color.Blue
                },
                text: {
                    fontSize: "3.86vw",
                    justifySelf: "center",
                    color: Color.Blue
                } 
            },
            openRateWrapper: {
                marginTop: "2.41vw",
                display: "flex"
            },
            openRate: {
                background: Color.OldLace,
                padding: "3.86vw 0",
                width: "43.96vw",
                height: "auto",
                borderRadius: "3.62vw",
                value: {
                    fontSize: "7.72vw",
                    justifySelf: "center",
                    color: Color.HarvestGold
                },
                text: {
                    fontSize: "3.38vw",
                    justifySelf: "center",
                    color: Color.HarvestGold,
                    marginTop: "1.44vw"
                },
                totalText: {
                    fontSize: "2.41vw",
                    justifySelf: "center",
                    color: Color.HarvestGold,
                    marginTop: "0.48vw"
                },
                chart: {
                    marginTop: "8.93vw",
                    width: "23.42vw",
                    height: "23.42vw",
                    justifySelf: "center"
                },
                chartColors: {
                    colors: [
                        { colorCode: Color.HarvestGold, statusText: 'Opened' },
                        { colorCode: Color.ChampagneGold, statusText: 'Not Opened' }
                    ]
                },
                status: {
                    margin: "9.66vw 0 0 3.86vw"
                },
                openedWrapper: {
                    display: "flex"
                },
                dot: {
                    borderRadius: "50%",
                    width: "2.89vw",
                    height: "2.89vw",
                    marginTop: "1vw"
                },
                statusText: {
                    marginLeft: "2.41vw",
                    color: Color.HarvestGold,
                    fontFamily: Font.Poppins,
                    fontSize: "3.38vw",
                    width: "33vw"
                },
                notOpenedWrapper: {
                    display: "flex",
                    marginTop: "1.93vw"
                },
            },
            filteredWrapper: {
                background: Color.Nyanza,
                width: "43.96vw",
                padding: "3.86vw 0",
                height: "auto",
                borderRadius: "3.62vw",
                marginLeft: "2.41vw",
                value: {
                    fontSize: "7.72vw",
                    justifySelf: "center",
                    color: Color.Green
                },
                text: {
                    fontSize: "3.38vw",
                    justifySelf: "center",
                    color: Color.Green,
                    marginTop: "1.44vw"
                },
                filteredText: {
                    fontSize: "2.41vw",
                    justifySelf: "center",
                    color: Color.Green,
                    marginTop: "0.48vw"
                },
                chart: {
                    marginTop: "8.93vw",
                    width: "23.42vw",
                    height: "23.42vw",
                    justifySelf: "center"
                },
                chartColors: {
                    colors: [
                        { colorCode: Color.Green, statusText: 'Opened' },
                        { colorCode: Color.MintGreen, statusText: 'Not Opened' }
                    ]
                },
                status: {
                    margin: "9.66vw 0 0 3.86vw"
                },
                openedWrapper: {
                    display: "flex"
                },
                dot: {
                    borderRadius: "50%",
                    width: "2.89vw",
                    height: "2.89vw",
                    marginTop: "1vw"
                },
                statusText: {
                    marginLeft: "2.41vw",
                    color: Color.Green,
                    fontFamily: Font.Poppins,
                    fontSize: "3.38vw",
                    width: "33vw"
                },
                notOpenedWrapper: {
                    display: "flex",
                    marginTop: "1.93vw"
                }
            }
        },
        pieChartComponet: {
            chartWrapper: {
                position: "relative", 
                width: "100%", 
                height: "100%"
            },
            countWrapper: {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
                fontFamily: Font.Poppins
            },
            count: {
                fontSize: "10.63vw", 
                fontWeight: "600" 
            },
            name: {
                fontSize: "3.86vw",
                fontWeight: "600"
            },
            toolTipWrapper: {
                width: "25vw",
                height: "auto",
                position: 'absolute',
                transform: 'translate(-50%, -100%)' 
            },
            toolTip: {
                display: "flex", 
                colorCode: {
                    width: "3vw",
                    height: "3vw",
                    display: "inline-block",
                    flex: "0 0 auto",
                    lineHeight: 0,
                    margin: "1vw 1.93vw 0 0",
                    borderRadius: "0.48vw"
                },
                status: {
                    width: 'auto'
                }
            }
        },
        statusWrapper: {
            marginTop: "12.07vw",
            background: Color.Cultured,
            width: "89.85vw",
            height: "auto",
            padding: "3.86vw 0",
            borderRadius: "3.62vw",
            title: {
                fontSize: "3.86vw",
                justifySelf: "center",
                color: Color.Black
            },
            chart: {
                margin: "7.24vw 0",
                width: "65.65vw",
                height: "65.65vw",
                justifySelf: "center"
            },
            statusList: {
                margin: "0 3.86vw",
                display: "flex",
                flexDirection: "row", 
                flexWrap: "wrap",
                gap: "1.44vw",
                justifyContent: "center"
            },
            status: {
                display: "flex",
                alignItems: "center",
                width: "auto",
                marginLeft: "2.42vw",
                color: {
                    width: "2.89vw",
                    height: "2.89vw",
                    borderRadius: "50%"
                },
                name: {
                    marginLeft: "0.96vw",
                    fontFamily: Font.Poppins,
                    color: Color.SharpAsh,
                    fontSize: "3.86vw"
                }
            }
        },
        applicationsByDate: {
            title: {
                margin: "12.07vw 0 0 7.24vw",
                fontSize: "3.86vw",
                color: Color.Black
            },
            chartWrapper: {
                width: "100%",
                height: "117.14vw",
                marginTop: "4.1vw",
                overflowY: "hidden",
                overflowX: "auto", 
                scrollbarWidth: "thin",
                scrollbarColor: "#ccc #f5f5f5"
            },
            chart: {
                width: "200%",
                height: "100%"
            },
            barChart: {
                marginLeft: "-4.83vw"
            },
            toolTip: {
                border: "3px solid" + Color.DarkAsh,
                padding: "3vw",
                background: Color.Cultured,
                lable: {
                    fontWeight: "500"
                },
                count: {
                    color: Color.Blue
                }
            }
        },
        jobsStatisticsWrapper: {
            margin: "19.32vw 0 2.77vw 0",
            title: {
                fontSize: "6.03vw"
            },
            selectWrapper: {
                marginTop: "5.79vw",
            },
            selectRow: {
                display: "flex",
                flexDirection: "row"
            },
            perPageSelect: {
                marginLeft: "auto",                
                marginTop: "unset",
                label: {
                    fontWeight: "400"
                },
                buttonWrapper: { 
                    width: "13.58vw"
                },
                button: {
                    width: "auto",
                    marginLeft: "auto"
                },
                hover: {
                    width: "13.58vw"
                }
            }
        },
        vacancyCard: {
            padding: "4.95vw 2.41vw 4.83vw",
            borderBottom: "1px solid " + Color.MiddleAsh,
            jobTitleWrapper: {
                display: "flex"
            },
            jobTitle: {
                fontSize: "3.86vw",
                fontWeight: "bold" as "bold",
                color: Color.Black,
                maxWidth: "65vw"
            },
            jobType: {
                display: "flex",
                fontSize: "2.89vw",
                fontWeight: "500",
                width: "15.7vw",
                height: "4.83vw",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "6.03vw",
                marginLeft: "auto"
            },
            jobId: {
                marginTop: "1.32vw",
                fontSize: "2.65vw",
                color: Color.MiddleBlack,
                bold: {
                    fontSize: "2.65vw",
                    fontWeight: "bold" as "bold",
                    color: Color.Black
                }
            },
            dateWrapper: {
                display: "flex",
                marginTop: "1.32vw"
            },
            createdText: {
                fontSize: "2.65vw",
                color: Color.MiddleBlack
            },
            calendarIcon: {
                width: "1.87vw",
                height: "2.14vw",
                fill: Color.DeepAsh,
                marginRight: "1.87vw"
            },
            date: {
                fontSize: "2.65vw",
                fontWeight: "bold",
                marginLeft: "1.21vw",
                color: Color.MiddleBlack
            },
            applicationDetails: {
                marginTop: "3.26vw",
                display: "flex"
            },
            totalApplication: {
                fontWeight: "bold"
            },
            applicationCount: {
                fontSize: "3.86vw"
            },
            applicationText: {
                fontSize: "3.38vw",
                color: Color.SharpAsh
            },
            openApplications: {
                marginLeft: "10.86vw",
                fontWeight: "bold"
            },
            openCount: {
                fontSize: "3.86vw"
            }, 
            openText: {
                fontSize: "3.38vw",
                color: Color.SharpAsh
            }
        },
        pagination: {
            nextButton: {
                width: "7.25vw",
                height: "7.25vw",
                backgroundColor: Color.DeepBlack,
                border: "none"
            },
            button: {
                color: Color.LightBlack,
                active: {
                    backgroundColor: Color.SharpAsh
                }
            }
        },
        perPageSelect: {
            marginLeft: "auto",                
            marginTop: "unset",
            buttonWrapper: { 
                width: "13.58vw"
            },
            button: {
                width: "auto",
                marginLeft: "auto"
            },
            hover: {
                width: "13.58vw"
            }
        },
        noVacancies: {
            wrapper: {
                borderRadius: "2.77vw",
                border: "1px solid " + Color.HarvestGold,
                backgroundColor: Color.LightGold,
                display: "flex",
                alignItems: "center" as "center",
                justifyContent: "center" as "center",
                padding: "2.41vh",
                color: Color.HarvestGold,
                fontSize: "4.5vw",
                fontFamily: Font.Poppins,
                margin: "21.73vw auto 0 auto",
                textAlign: "center"
            },
            icon: {
                marginRight: "1.43vw",
                width: "8.33vw",
                height: "8.33vw",
                marginLeft: "1vw"
            }
        }
    },
    desktop: {
        mainWrapper: {            
            flexDirection: "row" as "row",
            padding: "1.56vw 0.7vw 1.56vw 1.56vw"
        },        
        leftWrapper: {},
        rightWrapper: {
            width: "100%",
            padding: "0 0 0 2.32vw"
        },
        buttonWrapper: {
            display: "flex",
            flexDirection: "row" as "row",
            height: "4.68vw",
            justifyContent: "space-between",
            marginBottom: "2vw"
        },
        selectWrapper: {
            flexDirection: "row",
            margin: "1.56vw 0 0 20.5vw"
        },
        backButton: {            
            wrapper: {
                display: "block",
                alignSelf: "center",
                marginLeft: "unset",
                marginTop: "unset",
                width: "7vw"                 
            },
            container: {
                display: "flex",
                alignItems: "center"
            },
            button: {
                paddingTop: "0.3vw",
                backgroundColor: Color.Ash, 
                width: "2.60vw",
                height: "2.60vw",
                borderRadius: "50%"
            },
            icon: {
                fill: Color.DeepBlack,
                width: "50%"
            },
            text: {
                display: "inline",
                marginLeft: "1.3vw",
                fontSize: " 0.93vw",
                fontWeight: 'bold',
                color: Color.LightBlack
            }          
        },
        orgSelect: {
            buttonWrapper: { 
                width: "15.76vw"
            },
            button: {
                height: "1.82vw"
            },
            hover: {
                width: "15.76vw"
            }
        },
        statisticSection: {
            display: "flex"
        },
        title: {
            fontSize: "2.60vw",
            color: Color.DeepBlack
        },
        jobNameWrapper: {
            flexDirection: "row" as "row",
            marginTop: "1.19vw",
            fontSize: "1.56vw",
            color: Color.DeepBlack,
            jobName: {
                marginLeft: "0.6vw"
            }
        },
        filterPanel: {
            display: "flex",
            marginTop: "unset",
            borderRadius: "0.52vw",
            padding: "0.625vw",
            marginLeft: "auto",
            jobSelect: {
                label: {
                    fontSize: "0.83vw"
                },
                button: {
                    width: "13.33vw",
                    height: "1.82vw",
                    marginLeft: "0.625vw",
                    borderRadius: "0.52vw"
                },
                buttonText: {
                    marginLeft: "1.04vw",
                    maxWidth: "9.5vw"
                },
                buttonIcon: {       
                    marginRight: "0.77vw"
                },
                hover: {
                    width: "13.33vw",
                    maxHeight: "12.33vw"
                }
            },
            date: {
                marginTop: "unset",
                marginLeft: "1.67vw"
            },
            text: {
                fontSize: "0.83vw"
            },
            dateInput: {
                width: "8.98vw",
                height: "1.82vw",
                fontSize: "0.83vw",
                padding: "0 1.04vw",
                marginLeft: "0.625vw",
                borderRadius: "0.52vw"             
            },
            applyButton: {
                width: "7.5vw",
                height: "1.82vw",
                borderRadius: "0.52vw",
                fontSize: "0.94vw",
                margin: "0 0 0 0.83vw"
            }
        },
        jobCategoryWrapper: {
            display: "flex",
            marginTop: "1.56vw"
        },
        jobCategory: {
            padding: "0",
            overflow: "none",
            alignItems: "center",
            tag: {
                height: "1.82vw",
                lineHeight: "1.82vw",
                borderRadius: "1.30vw",
                padding: "0 1.04vw",
                fontSize: "0.94vw",
                fontWeight: "500",
                marginRight: "0.52vw",
                cursor: "pointer"
            }
        },
        exportExcel: {
            wrapper: {                
                margin: "0 0 0 auto"
            },
            button: {
                width: "10.83vw",
                height: "1.82vw",
                borderRadius: "0.52vw",
                fontSize: "0.94vw"
            },
            icon: {
                width: "0.91vw",
                height: "0.78vw",
                marginRight: "0.49vw"
            }
        },
        applicationsSummary: {
            marginTop: "1.61vw",
            display: "flex",
            totalApplications: {
                width: "14.16vw",
                height: "7.29vw",
                borderRadius: "0.78vw",
                paddingTop: "unset",
                count: {
                    marginTop: "1.3vw",
                    fontSize: "2.29vw"
                },
                text: {
                    fontSize: "0.83vw"
                } 
            },
            openRateWrapper: {
                marginTop: "unset"
            },
            openRate: {
                padding: "unset",
                width: "29.01vw",
                height: "7.29vw",
                borderRadius: "0.78vw",
                marginLeft: "1.56vw",
                display: "flex",
                value: {
                    fontSize: "2.29vw",
                    justifySelf: "unset",
                    margin: "0.78vw 0 0 1.08vw"
                },
                text: {
                    fontSize: "0.83vw",
                    justifySelf: "unset",
                    margin: "0 0 0 1.08vw",
                    textAlign: "center"
                },
                totalText: {
                    fontSize: "0.625vw",
                    justifySelf: "unset",
                    margin: "0 0 0 1.08vw",
                    textAlign: "center"
                },
                chart: {
                    margin: "0.93vw 0 0 1.92vw",
                    width: "5.05vw",
                    height: "5.05vw",
                    justifySelf: "unset"
                },
                status: {
                    margin: "1.53vw 0 0 1.08vw"
                },
                dot: {
                    width: "0.625vw",
                    height: "0.625vw",
                    marginTop: "0.3vw"
                },
                statusText: {
                    marginLeft: "0.52vw",
                    fontSize: "0.83vw",
                    width: "9vw"
                },
                notOpenedWrapper: {
                    marginTop: "0.26vw"
                }
            },
            filteredWrapper: {
                width: "29.06vw",
                padding: "unset",
                height: "7.29vw",
                borderRadius: "0.78vw",
                marginLeft: "1.3vw",
                display: "flex",
                value: {
                    fontSize: "2.29vw",
                    justifySelf: "unset",
                    margin: "0.78vw 0 0 1.08vw"
                },
                text: {
                    fontSize: "0.83vw",
                    justifySelf: "unset",
                    margin: "0 0 0 1.08vw",
                    textAlign: "center"
                },
                filteredText: {
                    fontSize: "0.625vw",
                    justifySelf: "unset",
                    margin: "0 0 0 1.08vw",
                    textAlign: "center"
                },
                chart: {
                    margin: "0.93vw 0 0 1.92vw",
                    width: "5.05vw",
                    height: "5.05vw",
                    justifySelf: "unset"
                },
                status: {
                    margin: "1.53vw 0 0 1.08vw"
                },
                dot: {
                    width: "0.625vw",
                    height: "0.625vw",
                    marginTop: "0.3vw"
                },
                statusText: {
                    marginLeft: "0.52vw",
                    fontSize: "0.83vw",
                    width: "9vw"
                },
                notOpenedWrapper: {
                    marginTop: "0.26vw"
                }
            }
        },
        pieChartComponet: {
            count: {
                fontSize: "2.29vw"
            },
            name: {
                fontSize: "0.83vw"
            },
            toolTipWrapper: {
                width: "auto",
                height: "auto",
                display: "inline-table"
            },
            toolTip: {
                colorCode: {
                    width: "1vw",
                    height: "1vw",
                    margin: "0 0.5vw 0 0",
                    borderRadius: "0.1vw"
                },
                status: {
                    fontSize: "0.83vw",
                    width: "max-content"
                }
            }
        },
        applicationStatusWrapper: {
            display: "flex",
            flexDirection: "row",
            marginTop: "2.6vw",
        },
        statusWrapper: {
            order: 2,
            marginTop: "unset",
            width: "22.91vw",
            height: "auto",
            padding: "1.56vw 0",
            borderRadius: "0.78vw",
            title: {
                fontSize: "0.83vw",
            },
            chart: {
                margin: "1.56vw 0",
                width: "14.15vw",
                height: "14.15vw"
            },
            statusList: {
                margin: "0 1.56vw",
                gap: "0.4vw"
            },
            status: {
                marginLeft: "0.43vw",
                color: {
                    width: "0.625vw",
                    height: "0.625vw"
                },
                name: {
                    marginLeft: "0.52vw",
                    fontSize: "0.83vw"
                }
            }
        },
        applicationsByDate: {
            order: 1,
            marginRight: "1.13vw",
            title: {
                margin: "0 0 0 1.56vw",
                fontSize: "0.83vw"
            },
            chartWrapper: {
                width: "50.78vw",
                height: "25.26vw",
                marginTop: "0.88vw"
            },
            chart: {
                width: "100%",
                height: "100%"
            },
            barChart: {
                marginLeft: "-1.5vw"
            },
            toolTip: {
                padding: "0.5vw",
                lable: {
                    fontSize: "1.04vw"
                },
                count: {
                    fontSize: "1.04vw"
                }
            }
        },
        jobsStatisticsWrapper: {
            margin: "7.03vw 0 1.64vw 0.88vw",
            display: "flex",
            title: {
                fontSize: "1.25vw"
            },
            selectWrapper: {
                margin: "0 0 0 auto",
            },
            selectRow: {
                display: "flex",
                flexDirection: "row"
            }
        },
        vacancyCard: {
            padding: "0 1.06vw 0 0.93vw",
            display: "flex",
            jobTitleWrapper: {
                marginTop: "1.74vw"
            },
            jobTitle: {
                fontSize: "1.04vw",
                maxWidth: "14.5vw",
                width: "14.89vw"
            },
            jobType: {
                fontSize: "0.78vw",
                width: "5.46vw",
                height: "1.56vw",
                borderRadius: "1.3vw",
                margin: "1.56vw 0 0 4.82vw"
            },
            jobId: {
                margin: "1.74vw 0 0 5.83vw",
                fontSize: "0.83vw",
                bold: {
                    fontSize: "0.83vw"
                }
            },
            dateWrapper: {
                margin: "1.87vw 0 1.3vw 5.2vw",
                flexDirection: "column"
            },
            createdText: {
                fontSize: "0.83vw",
                color: Color.DeepAsh
            },
            calendarIcon: {
                width: "0.7vw",
                height: "0.8vw",
                marginRight: "0.81vw"
            },
            date: {
                fontSize: "0.83vw",
                marginLeft: "1.52vw",
                marginTop: "0.15vw"
            },
            applicationDetails: {
                margin: "1.69vw 0 0 auto"
            },
            applicationCount: {
                fontSize: "1.04vw"
            },
            applicationText: {
                fontSize: "0.83vw"
            },
            openApplications: {
                marginLeft: "2.08vw"
            },
            openCount: {
                fontSize: "1.04vw"
            }, 
            openText: {
                fontSize: "0.83vw"
            }
        },
        paginationWrapper: {
            display: "flex",
            alignItems: "center",
            marginTop: "2.60vw"
        },
        pagination: {
            margin: "unset",
            marginLeft: "auto",
            nextButton: {
                width: "2.60vw",
                height: "2.60vw",
            }
        },
        perPageSelect: {
            marginBottom: "unset",
            marginLeft: "unset",
            label: {
                fontWeight: "400",
                fontSize: "0.83vw"
            },
            buttonWrapper: { 
                width: "4.06vw",
                height: "1.82vw"
            },
            button: {
                height: "1.82vw",
                marginLeft: "1.04vw"
            },
            hover: {
                width: "4.06vw"
            }
        },
        noVacancies: {
            wrapper: {
                width: "75%",
                borderRadius: "0.52vw",
                margin: "10vh auto 0 auto",
                padding: "1.56vw 0 1.56vw 0",
                fontSize: "1.137vw"
            },
            icon: {
                marginRight: "1.02vw",
                width: "1.58vw",
                height: "1.58vw"
            }
        }
    }
}